import { isSupportedLang } from "@/i18n/supportedLangs";
import type { SupportedLangs } from "@/i18n/types";

const PREFERRED_LANG_STORAGE_KEY = "app.preferredLang";

export const loadPreferredLang = (): SupportedLangs | null => {
  try {
    const raw = localStorage.getItem(PREFERRED_LANG_STORAGE_KEY);
    if (raw === null || !isSupportedLang(raw)) return null;
    return raw;
  } catch {
    return null;
  }
};

export const savePreferredLang = (lang: SupportedLangs): void => {
  // localStorage はストレージ無効環境（embedded webview 等）で例外を投げる。
  // 永続化は best-effort なので失敗は黙って捨てる。
  try {
    localStorage.setItem(PREFERRED_LANG_STORAGE_KEY, lang);
  } catch {
    // noop
  }
};

const resolveBrowserLang = (): SupportedLangs =>
  navigator.language.toLowerCase().startsWith("ja") ? "ja" : "en";

export const resolvePreferredLangOrBrowserDefault = (): SupportedLangs =>
  loadPreferredLang() ?? resolveBrowserLang();
